import { baseUrl } from "@environment/apiConfig";
import axios from "axios";

const instance = axios.create({
  baseURL: baseUrl,
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    // "X-Api-Key": apiKey,
  },
});

export default instance;
